import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// Import your screenshots
import watchdog1 from "../../assets/img/docs/watchdog-1.png";
import watchdog2 from "../../assets/img/docs/watchdog-2.png";
import watchdog3 from "../../assets/img/docs/watchdog-3.png";

const AddWatchdog = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className="py-5 watchdog-add-docs">
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              {/* Title */}
              <Card.Title className="display-6 mb-3">
                {t("documentation.watchdog.add.title")}
              </Card.Title>

              {/* Description */}
              <Card.Text className="text-muted mb-3">
                {t("documentation.watchdog.add.description")}
              </Card.Text>

              {/* How to access */}
              <Card.Text className="fw-semibold mb-3">
                {t("documentation.watchdog.add.howToAccess")}
              </Card.Text>

              {/* Fields list */}
              <ul className="overview-list">
                <li>
                  <strong>
                    {t("documentation.watchdog.add.fields.actionType")}
                  </strong>
                </li>
                <li>
                  <strong>
                    {t("documentation.watchdog.add.fields.interval")}
                  </strong>
                </li>
                <li>
                  <strong>
                    {t("documentation.watchdog.add.fields.amount")}
                  </strong>
                </li>
                <li>
                  <strong>
                    {t("documentation.watchdog.add.fields.service")}
                  </strong>
                </li>
                <li>
                  <strong>
                    {t("documentation.watchdog.add.fields.unitType")}
                  </strong>
                </li>
                <li>
                  <strong>
                    {t("documentation.watchdog.add.fields.warnings")}
                  </strong>
                </li>
                <li>
                  <strong>
                    {t("documentation.watchdog.add.fields.suspendInterval")}
                  </strong>
                </li>
              </ul>

              {/* Screenshots */}
              {/* Screenshots */}
              <Row className="g-3 mt-4">
                {[watchdog1, watchdog2, watchdog3].map((img, idx) => (
                  <Col md={6} key={idx}>
                    <Image
                      src={img}
                      alt={`Add Watchdog screenshot ${idx + 1}`}
                      className="section-image shadow-sm"
                      rounded
                      fluid
                    />
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddWatchdog;
